import Vue from 'vue'
import VueRouter from 'vue-router'
import { Message as ElMessage } from 'element-ui'
import Home from '@/views/Home.vue'
import Login from '@/views/Login.vue'
import Register from '@/views/Register.vue'
import KakaoCallback from '@/views/KakaoCallback.vue'
import OrderBundle from '@/views/member/OrderBundle.vue'//我的页面-订单
import AgencyShipping from '@/views/member/AgencyShipping.vue'//申请运输代理
import AgencyShippingWrite from '@/views/member/AgencyShippingWrite.vue'//申请运输代理写入
import DeliveryAuto from '@/views/member/DeliveryAuto.vue' //自动注册指南
import AgencyShopping from '@/views/member/AgencyShopping.vue'//采购代理申请
import AgencyShoppingWrite from '@/views/member/AgencyShoppingWrite.vue'//采购代理申请写入
import AgencyShippingEdit from '@/views/member/AgencyShippingEdit.vue'
import AgencyShoppingEdit from '@/views/member/AgencyShoppingEdit.vue'

import DocumentStart from '@/views/personal/DocumentStart.vue'//个人会员-开始使用
import DocumentProcess from '@/views/personal/DocumentProcess.vue'//个人会员-直接购买信息
import DocumentBenefit from '@/views/personal/DocumentBenefit.vue' //个人会员-福利
import DocumentAwards from '@/views/personal/DocumentAwards.vue' //个人会员-奖项
import DocumentReview from '@/views/personal/DocumentReview.vue' //个人会员-评论
import ReviewDetails from '@/views/personal/ReviewDetails.vue' //个人会员-评论详情
import ReviewWriteble from '@/views/personal/ReviewWriteble.vue' //个人会员-可写评论
import ReviewWrite from '@/views/personal/ReviewWrite.vue' //个人会员-写评论
import DeliveryGuide from '@/views/personal/DeliveryGuide.vue' //个人会员-船务代理
import DeliveryPrice from '@/views/personal/DeliveryPrice.vue' //个人会员、商业会员-运费
import AddService from '@/views/personal/AddService.vue' //个人会员-附加服务
import CustomsInfo from '@/views/personal/CustomsInfo.vue' //个人会员-报关
import TeamMoney from '@/views/personal/TeamMoney.vue'//个人会员-团队资金

import BizSupport from '@/views/business/BizSupport.vue'//商业会员-业务支持
import BizDeliveryGuide from '@/views/business/BizDeliveryGuide.vue'//商业会员-船务代理
import ShoppingGuide from '@/views/business/ShoppingGuide.vue'//商业会员-采购代理
import InventoryGuide from '@/views/business/InventoryGuide.vue'//商业会员-库存/存储
import InventoryWrite from '@/views/inventory/InventoryWrite.vue'//商业会员-库存/存储-产品登记
import ItemXlsUpload from '@/views/inventory/ItemXlsUpload.vue'//商业会员-库存/存储-产品EXCEL导入
import WarehouseXlsUpload from '@/views/inventory/WarehouseXlsUpload.vue'//商业会员-库存/存储- 入库 Excel 登记 
import PackingXlsUpload from '@/views/inventory/PackingXlsUpload.vue'//商业会员-库存/存储- 发货 Excel 导入 

import InventoryItem from '@/views/inventory/InventoryItem.vue' //商业会员-库存情况
import WarehouseWrite from '@/views/inventory/WarehouseWrite.vue' //商业会员-仓库登记
import InventoryWarehouse from '@/views/inventory/InventoryWarehouse.vue' //商业会员-入库情况
import InventoryWarehouseComplete from '@/views/inventory/InventoryWarehouseComplete.vue' //商业会员-入库保管
import InventoryPackingWrite from '@/views/inventory/InventoryPackingWrite.vue' //商业会员-发送申请
import InventoryPacking from '@/views/inventory/InventoryPacking.vue' //商业会员-发货情况
import InventoryPackingEdit from '@/views/inventory/InventoryPackingEdit.vue'//库存申请修改

import BizAddService from '@/views/business/BizAddService.vue' //商业会员-附加服务
import PayGuide from '@/views/business/PayGuide.vue'//商业会员-代理支付
import BizCustomsInfo from '@/views/business/BizCustomsInfo.vue'//商业会员-报关
import DocumentLcl from '@/views/business/DocumentLcl.vue'//商业会员-LCL货运
import BizTeamMoney from '@/views/business/BizTeamMoney.vue'//商业会员-团队资金

import NoticeList from '@/views/support/NoticeList.vue'//客户支持-公告事项
import NoticeDetails from '@/views/support/NoticeDetails.vue'//客户支持-公告详情
import QuestionList from '@/views/support/QuestionList.vue'//客户支持-常见问题解答
import QuestionDetails from '@/views/support/QuestionDetails.vue'//客户支持-常见问题详情
import OneConsult from '@/views/support/OneConsult.vue'//客户支持 - 1:1联系
import AddOneConsult from '@/views/support/AddOneConsult.vue'//客户支持 - 1:1联系 新增
import OneConsultDetails from '@/views/support/OneConsultDetails.vue'//客户支持 - 1:1联系 详情
import DocumentInsure from '@/views/support/DocumentInsure.vue'//客户支持 - 安全补偿
import BoardEvent from '@/views/support/BoardEvent.vue'//客户支持 - 活动
import EventDetails from '@/views/support/EventDetails.vue'//客户支持 - 活动详情
import Partnership from '@/views/support/Partnership.vue'//客户支持 - 团队合作
import DocumentSchedule from '@/views/support/DocumentSchedule.vue' //发货时间
import DocumentSize from '@/views/support/DocumentSize.vue' //尺寸条件表
import DocumentAddress from '@/views/support/DocumentAddress.vue' //我的中国地址

import AddressBook from '@/views/member/AddressBook.vue' //送货地址列表
import MemberInfo from '@/views/member/MemberInfo.vue'//修改会员信息
import Message from '@/views/member/Message.vue' //消息箱列表
import MessageDetails from '@/views/member/MessageDetails.vue' //消息箱详情内容页
import Nodata from '@/views/member/Nodata.vue' //无数据
import NodataDetails from '@/views/member/NodataDetails.vue'//无数据详情
import AgencyList from '@/views/member/AgencyList.vue' //代理申请列表
import AgencyDetails from '@/views/member/AgencyDetails.vue' //代理申请详情
import InventoryList from '@/views/member/InventoryList.vue' //库存申报列表
import InventoryDetails from '@/views/member/InventoryDetails.vue' //库存申报详情
import Cash from '@/views/member/Cash.vue'//人民币保证金
import Pay from '@/views/member/Pay.vue'//付款记录
import Coupon from '@/views/member/Coupon.vue'//我的优惠券
import CyberCashHistory from '@/views/member/CyberCashHistory.vue'//团队资金充值/使用记录
import AgencyInvoiceWrite from '@/views/member/AgencyInvoiceWrite.vue' //支付 汇款 发票 申请
import XlsUpload from '@/views/member/XlsUpload.vue'
import Test from '@/views/member/Test.vue'

import InventoryCoupang from '@/views/coupang/InventoryCoupang.vue'//Coupang-库存/存储
import Terms from '@/views/support/Terms.vue'//使用条款
import PrivacyPolicy from '@/views/support/PrivacyPolicy.vue'//隐私政策

Vue.use(VueRouter)

// 解决Vue Router导航冗余报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
	if (onResolve || onReject) {
		return originalPush.call(this, location, onResolve, onReject)
	}
	// 捕获所有导航的Promise错误
	return originalPush.call(this, location).catch(err => {
		// 只忽略重定向导致的错误，其他错误正常抛出
		if (err.name !== 'NavigationDuplicated' && !err.message.includes('Redirected when going from')) {
			return Promise.reject(err)
		}
		return err
	})
}

const routes = [
	{ path: '/', name: 'home', component: Home, meta: { requiresAuth: false } },
	{ path: '/login', name: 'login', component: Login, meta: { requiresAuth: false } },
	{ path: '/register', name: 'register', component: Register, meta: { requiresAuth: false } },
	{ path: '/orderBundle', name: 'orderbundle', component: OrderBundle, meta: { requiresAuth: true } },
	{ path: '/agencyShipping', name: 'agencyshipping', component: AgencyShipping, meta: { requiresAuth: true } },
	{ path: '/agencyShippingWrite', name: 'agencyshippingwrite', component: AgencyShippingWrite, meta: { requiresAuth: true } },
	{ path: '/deliveryAuto', name: 'deliveryauto', component: DeliveryAuto, meta: { requiresAuth: true } },
	{ path: '/agencyShopping', name: 'agencyshopping', component: AgencyShopping, meta: { requiresAuth: true } },
	{ path: '/agencyShoppingWrite', name: 'agencyshoppingwrite', component: AgencyShoppingWrite, meta: { requiresAuth: true } },
	{ path: '/agencyShippingEdit', name: 'agencyshippingedit', component: AgencyShippingEdit, meta: { requiresAuth: true } },
	{ path: '/agencyShoppingEdit', name: 'agencyshoppingedit', component: AgencyShoppingEdit, meta: { requiresAuth: true } },
	{ path: '/documentStart', name: 'documentstart', component: DocumentStart, meta: { requiresAuth: false } },
	{ path: '/documentProcess', name: 'documentprocess', component: DocumentProcess, meta: { requiresAuth: false } },
	{ path: '/documentBenefit', name: 'documentbenefit', component: DocumentBenefit, meta: { requiresAuth: false } },
	{ path: '/documentAwards', name: 'documentawards', component: DocumentAwards, meta: { requiresAuth: false } },
	{ path: '/documentReview', name: 'documentreview', component: DocumentReview, meta: { requiresAuth: false } },
	{ path: '/reviewDetails/:id', props: true, name: 'reviewdetails', component: ReviewDetails, meta: { requiresAuth: false } },
	{ path: '/reviewWriteble', name: 'reviewwriteble', component: ReviewWriteble, meta: { requiresAuth: true } },
	{ path: '/reviewWrite/:id', props: true, name: 'reviewwrite', component: ReviewWrite, meta: { requiresAuth: true } },
	{ path: '/deliveryGuide', name: 'deliveryguide', component: DeliveryGuide, meta: { requiresAuth: false } },
	{ path: '/deliveryPrice', name: 'deliveryprice', component: DeliveryPrice, meta: { requiresAuth: false } },
	{ path: '/deliveryPriceBiz', name: 'deliverypricebiz', component: DeliveryPrice, meta: { requiresAuth: false } },
	{ path: '/addService', name: 'addservice', component: AddService, meta: { requiresAuth: false } },
	{ path: '/customsInfo', name: 'customsinfo', component: CustomsInfo, meta: { requiresAuth: false } },
	{ path: '/teamMoney', name: 'teammoney', component: TeamMoney, meta: { requiresAuth: false } },

	{ path: '/bizSupport', name: 'bizsupport', component: BizSupport, meta: { requiresAuth: false } },
	{ path: '/bizDeliveryGuide', name: 'bizdeliveryguide', component: BizDeliveryGuide, meta: { requiresAuth: false } },
	{ path: '/shoppingGuide', name: 'shoppingguide', component: ShoppingGuide, meta: { requiresAuth: false } },
	{ path: '/inventoryGuide', name: 'inventoryguide', component: InventoryGuide, meta: { requiresAuth: false } },
	{ path: '/inventoryWrite', name: 'inventorywrite', component: InventoryWrite, meta: { requiresAuth: true } },
	{ path: '/itemXlsUpload', name: 'itemxlsupload', component: ItemXlsUpload, meta: { requiresAuth: true } },
	{ path: '/warehouseXlsUpload', name: 'warehousexlsupload', component: WarehouseXlsUpload, meta: { requiresAuth: true } },
	{ path: '/packingXlsUpload', name: 'packingxlsupload', component: PackingXlsUpload, meta: { requiresAuth: true } },
	{ path: '/inventoryItem', name: 'inventoryitem', component: InventoryItem, meta: { requiresAuth: true } },
	{ path: '/warehouseWrite', name: 'warehousewrite', component: WarehouseWrite, meta: { requiresAuth: true } },
	{ path: '/inventoryWarehouse', name: 'inventorywarehouse', component: InventoryWarehouse, meta: { requiresAuth: true } },
	{ path: '/inventoryWarehouseComplete', name: 'inventorywarehousecomplete', component: InventoryWarehouseComplete, meta: { requiresAuth: true } },
	{ path: '/inventoryPackingWrite', name: 'inventorypackingwrite', component: InventoryPackingWrite, meta: { requiresAuth: true } },
	{ path: '/inventoryPacking', name: 'inventorypacking', component: InventoryPacking, meta: { requiresAuth: true } },
	{ path: '/inventoryPackingEdit', name: 'inventorypackingedit', component: InventoryPackingEdit, meta: { requiresAuth: true } },

	{ path: '/bizAddService', name: 'bizaddservice', component: BizAddService, meta: { requiresAuth: false } },
	{ path: '/payGuide', name: 'payguide', component: PayGuide, meta: { requiresAuth: false } },
	{ path: '/bizCustomsInfo', name: 'bizcustomsinfo', component: BizCustomsInfo, meta: { requiresAuth: false } },
	{ path: '/documentLcl', name: 'documentlcl', component: DocumentLcl, meta: { requiresAuth: false } },
	{ path: '/bizTeamMoney', name: 'bizteammoney', component: BizTeamMoney, meta: { requiresAuth: false } },
	{ path: '/noticeList', name: 'noticelist', component: NoticeList, meta: { requiresAuth: false } },
	{ path: '/noticeDetails/:id', props: true, name: 'noticedetails', component: NoticeDetails, meta: { requiresAuth: false } },
	{ path: '/questionList', name: 'questionlist', component: QuestionList, meta: { requiresAuth: false } },
	{ path: '/questionDetails/:id', props: true, name: 'questiondetails', component: QuestionDetails, meta: { requiresAuth: false } },
	{ path: '/oneConsult', name: 'oneconsult', component: OneConsult, meta: { requiresAuth: true } },
	{ path: '/addOneConsult', name: 'addoneconsult', component: AddOneConsult, meta: { requiresAuth: true } },
	{ path: '/oneConsultDetails/:id', props: true, name: 'oneconsultdetails', component: OneConsultDetails, meta: { requiresAuth: true } },
	{ path: '/documentInsure', name: 'documentinsure', component: DocumentInsure, meta: { requiresAuth: false } },
	{ path: '/boardEvent', name: 'boardevent', component: BoardEvent, meta: { requiresAuth: false } },
	{ path: '/eventDetails/:id', props: true, name: 'eventdetails', component: EventDetails, meta: { requiresAuth: false } },
	{ path: '/partnership', name: 'partnership', component: Partnership, meta: { requiresAuth: false } },
	{ path: '/documentSchedule', name: 'documentschedule', component: DocumentSchedule, meta: { requiresAuth: false } },
	{ path: '/documentSize', name: 'documentsize', component: DocumentSize, meta: { requiresAuth: false } },
	{ path: '/documentAddress', name: 'documentaddress', component: DocumentAddress, meta: { requiresAuth: true } },
	{ path: '/addressBook', name: 'addressbook', component: AddressBook, meta: { requiresAuth: true } },
	{ path: '/memberInfo', name: 'memberinfo', component: MemberInfo, meta: { requiresAuth: true } },
	{ path: '/message', name: 'message', component: Message, meta: { requiresAuth: true } },
	{ path: '/messageDetails/:id', props: true, name: 'messagedetails', component: MessageDetails, meta: { requiresAuth: true } },
	{ path: '/nodata', name: 'nodata', component: Nodata, meta: { requiresAuth: true } },
	{ path: '/nodataDetails/:id', props: true, name: 'nodatadetails', component: NodataDetails, meta: { requiresAuth: true } },
	{ path: '/agencyList', name: 'agencylist', component: AgencyList, meta: { requiresAuth: true } },
	{ path: '/agencyDetails/:id', props: true, name: 'agencydetails', component: AgencyDetails, meta: { requiresAuth: true } },
	{ path: '/inventoryList', name: 'inventorylist', component: InventoryList, meta: { requiresAuth: true } },
	{ path: '/inventoryDetails/:id', props: true, name: 'inventorydetails', component: InventoryDetails, meta: { requiresAuth: true } },

	{ path: '/cash', name: 'cash', component: Cash, meta: { requiresAuth: true } },
	{ path: '/pay', name: 'pay', component: Pay, meta: { requiresAuth: true } },
	{ path: '/coupon', name: 'coupon', component: Coupon, meta: { requiresAuth: true } },
	{ path: '/cyberCashHistory', name: 'cybercashhistory', component: CyberCashHistory, meta: { requiresAuth: true } },
	{ path: '/agencyInvoiceWrite', name: 'agencyinvoicewrite', component: AgencyInvoiceWrite, meta: { requiresAuth: true } },
	{ path: '/xlsUpload', name: 'xlsupload', component: XlsUpload, meta: { requiresAuth: true } },
	{ path: '/test', name: 'test', component: Test, meta: { requiresAuth: true } },
	{ path: '/inventoryCoupang', name: 'inventorycoupang', component: InventoryCoupang, meta: { requiresAuth: false } },
	{ path: '/terms', name: 'terms', component: Terms, meta: { requiresAuth: false } },
	{ path: '/privacyPolicy', name: 'privacypolicy', component: PrivacyPolicy, meta: { requiresAuth: false } },
	{ path: '/kakao-callback', name: 'kakaocallback', component: KakaoCallback, meta: { requiresAuth: false } },
]

const router = new VueRouter({
	mode: 'history', // 去掉 #
	routes,
	// 滚动行为
	scrollBehavior(to, from, savedPosition) {
		// 跳转新页面时，强制回到顶部（x: 水平位置, y: 垂直位置）
		return { x: 0, y: 0 }
		// 支持浏览器后退/前进时恢复滚动位置
		// if (savedPosition) {
		//   return savedPosition // 后退/前进时回到之前的位置
		// } else {
		//   return { x: 0, y: 0 } // 新跳转时回到顶部
		// }
	}
})



// 路由守卫：检查 token
// router.beforeEach((to, from, next) => {

// 	console.log(to,"to到")
// 	console.log(from,"from来")
// 	console.log(next,3)

//  const isAuthenticated = !!localStorage.getItem('token');

//    // 1. 如果目标路由需要认证且未认证
//    if (to.meta.requiresAuth && !isAuthenticated) {
//      // 如果已经在登录页，不重复跳转
//      if (from.path === '/login') {
//        return next();//false
//      }
//      // 记录当前想访问的页面，登录后可跳转回来
//      localStorage.setItem('redirectPath', to.fullPath);
//      return next('/login');
//    }

//    // 2. 如果已认证但想访问登录/注册页
//    if (isAuthenticated && (to.path === '/login' || to.path === '/register')) {
//      // 如果已经在首页，不重复跳转
//      if (from.path === '/') {
//        return next(false);
//      }
//      return next('/');
//    }

//    // 3. 正常情况直接放行
//    next();

// });

// 路由守卫实现
router.beforeEach((to, from, next) => {
	// 获取本地存储的token
	const token = localStorage.getItem('token')
	// 判断当前路由是否需要登录权限
	const requiresAuth = to.meta.requiresAuth

	// Coupang direct access redirect to personal center embedded mode
	if (token && to.query.type === 'coupang' && [
		'/inventoryWrite', '/itemXlsUpload', '/inventoryItem',
		'/warehouseWrite', '/warehouseXlsUpload', '/inventoryWarehouse', '/inventoryWarehouseComplete',
		'/inventoryPackingWrite', '/packingXlsUpload', '/inventoryPacking'
	].includes(to.path)) {
		let activeMenu = 'coupang_inventory_item';
		if (to.path === '/inventoryWrite') activeMenu = 'coupang_inventory_write';
		else if (to.path === '/itemXlsUpload') activeMenu = 'coupang_item_xls_upload';
		else if (to.path === '/inventoryItem') activeMenu = 'coupang_inventory_item';
		else if (to.path === '/warehouseWrite') activeMenu = 'coupang_warehouse_write';
		else if (to.path === '/warehouseXlsUpload') activeMenu = 'coupang_warehouse_xls_upload';
		else if (to.path === '/inventoryWarehouse') activeMenu = 'coupang_inventory_warehouse';
		else if (to.path === '/inventoryWarehouseComplete') activeMenu = 'coupang_inventory_warehouse_complete';
		else if (to.path === '/inventoryPackingWrite') activeMenu = 'coupang_inventory_packing_write';
		else if (to.path === '/packingXlsUpload') activeMenu = 'coupang_packing_xls_upload';
		else if (to.path === '/inventoryPacking') activeMenu = 'coupang_inventory_packing';

		return next({
			path: '/orderBundle',
			query: {
				...to.query,
				activeMenu: activeMenu
			}
		});
	}

	// Carry over type=coupang context when navigating from a coupang page without query params
	if (token && !to.query.type && (from.query.type === 'coupang' || from.query.activeMenu)) {
		let activeMenu = undefined;
		if (to.path === '/inventoryWrite') activeMenu = 'coupang_inventory_write';
		else if (to.path === '/itemXlsUpload') activeMenu = 'coupang_item_xls_upload';
		else if (to.path === '/inventoryItem') activeMenu = 'coupang_inventory_item';
		else if (to.path === '/warehouseWrite') activeMenu = 'coupang_warehouse_write';
		else if (to.path === '/warehouseXlsUpload') activeMenu = 'coupang_warehouse_xls_upload';
		else if (to.path === '/inventoryWarehouse') activeMenu = 'coupang_inventory_warehouse';
		else if (to.path === '/inventoryWarehouseComplete') activeMenu = 'coupang_inventory_warehouse_complete';
		else if (to.path === '/inventoryPackingWrite') activeMenu = 'coupang_inventory_packing_write';
		else if (to.path === '/packingXlsUpload') activeMenu = 'coupang_packing_xls_upload';
		else if (to.path === '/inventoryPacking') activeMenu = 'coupang_inventory_packing';

		if (activeMenu) {
			return next({
				path: '/orderBundle',
				query: {
					...to.query,
					type: 'coupang',
					activeMenu: activeMenu
				}
			});
		}
	}

	// 情况1: 需要登录权限，但未登录
	if (requiresAuth && !token) {
		// 记录当前想访问의 页面，登录后可跳转回来
		// 排除登录页本身，避免无限循环
		if (to.path !== '/login') {
			localStorage.setItem('redirectPath', to.fullPath)
			ElMessage.warning('로그인이 필요한 서비스입니다. 회원가입 또는 로그인 후 이용해주세요.')
		}
		// 未登录且需要权限，跳转到登录页
		next('/login')
	}
	// 情况2: 已登录，但访问登录/注册页
	else if (token && (to.path === '/login' || to.path === '/register')) {
		// 跳回来源页，如果是从首页来的则保持在首页
		next(from.path || '/')
	}
	// 情况3: 其他允许的访问
	else {
		next()
	}
})


export default router
